import * as types from '../actions/action-types';
import { createEmptyDetails, getInitialWeekString } from '../utils/releveHeures';

const initialState = {
    weekString: getInitialWeekString(),
    statut: 'BROUILLON',
    expandedDay: 'lundi',
    details: createEmptyDetails(),
    meta: {
        autorisationDir: 'non',
        reposRespectes: 'oui',
        remarquesRepos: '',
        signatureName: 'Christophe BRUNO',
        dateSignature: null,
        adresseIp: null,
        empreinteSha256: null
    },
    // Verrouillé par défaut : tant que le service n'a pas confirmé le statut réel en base, le formulaire reste bloqué
    loading: true,
    saving: false,
    error: null
};

export default function releveHeuresReducer(state = initialState, action) {
    switch (action.type) {
        case types.RELEVE_HEURES_SET_WEEK:
            return { ...state, weekString: action.payload };

        case types.RELEVE_HEURES_SET_EXPANDED_DAY:
            return { ...state, expandedDay: action.payload };

        case types.RELEVE_HEURES_SET_CHAMP: {
            const { jour, field, value } = action.payload;
            return { ...state, details: { ...state.details, [jour]: { ...state.details[jour], [field]: value } } };
        }

        case types.RELEVE_HEURES_SET_JOURNEE: {
            const { jour, valeurs } = action.payload;
            return { ...state, details: { ...state.details, [jour]: { ...state.details[jour], ...valeurs } } };
        }

        case types.RELEVE_HEURES_SET_META:
            return { ...state, meta: { ...state.meta, ...action.payload } };

        case types.RELEVE_HEURES_LOAD_REQUEST:
            return { ...state, loading: true, error: null };

        case types.RELEVE_HEURES_LOAD_SUCCESS: {
            const { statut, details, meta } = action.payload;
            return {
                ...state,
                loading: false,
                statut: statut || 'BROUILLON',
                // Semaine vide côté serveur (nouvelle semaine) => on repart d'un formulaire vierge, sans garder l'ancienne semaine
                details: details ? { ...createEmptyDetails(), ...details } : createEmptyDetails(),
                meta: meta
                    ? { ...state.meta, ...meta }
                    : { ...state.meta, reposRespectes: 'oui', remarquesRepos: '', dateSignature: null, adresseIp: null, empreinteSha256: null }
            };
        }

        case types.RELEVE_HEURES_LOAD_FAILURE:
            return { ...state, loading: false, statut: 'BROUILLON', error: action.error };

        case types.RELEVE_HEURES_SAVE_REQUEST:
            return { ...state, saving: true, error: null };

        case types.RELEVE_HEURES_SAVE_SUCCESS:
            return { ...state, saving: false };

        case types.RELEVE_HEURES_SAVE_FAILURE:
            return { ...state, saving: false, error: action.error };

        default:
            return state;
    }
}
